module.exports = __webpack_public_path__ + "img/landingpage_campaign01-fase02-03proteccionauto.3e751a64.jpg";